import { SVGProps } from "react"

export function AmphoraIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="100%"
      viewBox="0 0 1200 1200"
      height="150"
      {...props}
    >
      <g transform="translate(0,1200) scale(0.1,-0.1)" fill="currentColor" stroke="none">
        <path
          d="M5910 11986 c-40 -15 -789 -446 -835 -481 -17 -12 -44 -47 -60 -76
l-30 -54 -3 -1759 c-3 -1989 -9 -1831 76 -1914 34 -32 256 -166 792 -475 410
-236 762 -436 784 -443 117 -42 253 14 314 130 l27 51 5 895 c5 821 6 898 22
926 62 114 187 174 298 144 25 -7 177 -89 340 -182 162 -94 556 -321 875 -506
319 -184 595 -349 614 -366 18 -17 43 -51 55 -76 l21 -45 5 -2780 c5 -2687 6
-2781 24 -2815 26 -49 74 -98 121 -122 52 -27 148 -34 200 -16 50 18 1562 892
1593 921 12 11 34 44 47 72 l25 50 -2 2940 c-3 2885 -3 2941 -22 2979 -31 62
-72 95 -242 193 -229 132 -1330 767 -3204 1851 -899 519 -1652 951 -1674 958
-48 17 -119 17 -166 0z"
        />
        <path
          d="M2385 9951 c-69 -31 -1519 -871 -1543 -894 -12 -11 -34 -44 -47 -72
l-25 -50 2 -2940 c3 -2885 3 -2941 22 -2979 31 -62 72 -95 242 -193 229 -132
1330 -767 3204 -1851 899 -519 1652 -951 1674 -958 47 -17 111 -18 157 -2 54
18 780 439 821 476 20 18 47 54 60 80 l23 47 0 1795 0 1795 -30 54 c-16 29
-44 64 -61 78 -33 24 -1431 835 -1517 879 -130 67 -280 21 -351 -106 l-31 -55
-5 -930 -5 -930 -22 -41 c-59 -110 -203 -170 -313 -131 -59 22 -1773 1016
-1809 1050 -18 18 -43 52 -55 77 l-21 45 -5 2795 c-5 2739 -5 2796 -24 2834
-26 52 -79 104 -130 127 -54 25 -157 25 -211 0z"
        />
      </g>
    </svg>
  )
}
